import React, {Component, PropTypes} from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const FooterResume = () => {
  return (
    <footer id='footer' className='footer'>
      <div className='container'>
        <div className='row'>
          <div className='col-md-12'>
            <p className='copy-lft'>☕️🎾🥖🍣🍶🍱🍜☁️</p>
            <p className='copy-rht'>🍙🥐🍳✈️🍷🧀🥩🚀</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterResume;